import React from "react";

export default function ChatIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 36 36" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <path d="M18 3C9.716 3 3 8.611 3 15.5c0 3.917 2.133 7.401 5.469 9.703-.469 2.063-1.594 4.172-3.344 5.672-.25.219-.313.563-.156.844.125.25.375.406.656.406.031 0 .063 0 .094-.006 3.563-.438 6.594-2.25 8.469-3.875 1.188.25 2.438.381 3.719.381 8.284 0 15-5.611 15-12.5S26.284 3 18 3zm0 22.5c-1.219 0-2.438-.156-3.594-.469-.25-.063-.531 0-.75.156-1.406 1.063-3.594 2.563-6.25 3.375 1.125-1.531 1.875-3.25 2.188-4.969.063-.313-.063-.625-.313-.844C6.375 20.969 5.5 18.313 5.5 15.5 5.5 10.253 11.094 5.5 18 5.5S30.5 10.253 30.5 15.5 24.906 25.5 18 25.5z" fill={filteredStyles.fill || "#FFF"}/>
      <circle cx="11" cy="15.5" r="1.5" fill={filteredStyles.fill || "#FFF"}/>
      <circle cx="18" cy="15.5" r="1.5" fill={filteredStyles.fill || "#FFF"}/>
      <circle cx="25" cy="15.5" r="1.5" fill={filteredStyles.fill || "#FFF"}/>
    </svg>
  );
}
